/** Undo window for inbox sends (shared queue in ConversationView). */
export const INBOX_SEND_DELAY_SECONDS = 5;

export type InboxPendingSendState = {
  message: string;
  countdown: number;
  chatId?: string;
  /** When true, hide AI draft after this send is committed (countdown finished). */
  fromDraft?: boolean;
};
